import type { FaireProductEntity } from "../../entity_types/product";

export const p_nx7zdkdcrp: FaireProductEntity = {
  token: "p_nx7zdkdcrp",
  type: "product",
  name: "Luxe Lace Contrast Blazer Suit",
  brandToken: "b_mdfcwdnw57",
  brandName: "Red Clover USA",
  imageUrl:
    "https://cdn.faire.com/fastly/1de144cba7e0afaac765e2a687bef6ffe15e3dca7870243071866e96cdffac0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7056621528d2e045e7994bbe50853f7311a3f281fbc35015323beaf69a4c793.jpeg",
    "https://cdn.faire.com/fastly/5e36fedb21350d3ec608957f539fb906952c12eff4ee4a8227e9c938ed524264.jpeg",
    "https://cdn.faire.com/fastly/8c3a8a09e6c1d1029514a456c060c9f59b03f96b062ca87d227c2b68a79b604c.jpeg",
    "https://cdn.faire.com/fastly/2cd08428a009a249eee5f441da02bb98362970c28b7094a2e62795353389b495.jpeg",
    "https://cdn.faire.com/fastly/2a5088186fa2f58ae2b774c05027870809f1207144e3cdb330ada740c238d39e.jpeg",
    "https://cdn.faire.com/fastly/f032e3c69f5a4a2642ad3158e4b607938b4a343ba7271a740741a3c209e24096.jpeg",
    "https://cdn.faire.com/fastly/4669643d26152a1c976c7ed7fe6055f53a978fceb52cde1fb26df0c7c4b8175d.jpeg",
    "https://cdn.faire.com/fastly/c53f7d3398bfc2f7fb9cf04b88f626221e7605118931c91517dab267f415b4f2.jpeg",
    "https://cdn.faire.com/fastly/5f5c94767cb53a7bdbd506fa2e886e54b1ccb14f6f6954f15de5d80980737c42.jpeg",
    "https://cdn.faire.com/fastly/52e4fe677810fce6973c7f7303c1cbfc02490a64098e09cad624d8f382f015ef.jpeg",
  ],
  priceDollars: 58.88,
  description:
    "This Luxe Lace Contrast Blazer Suit exudes sophistication and boldness. Crafted with a structuRed silhouette, it features an exquisite lace corset detail that adds a touch of femininity to the tailoRed blazer design. The premium blend fabric ensures a sleek fit, while the unique lace accents create an elegant contrast. Perfect for high-fashion events or glamorous evenings, this statement piece is a true showstopper. Style it with minimalist heels for a modern, edgy look.\n\nSize Details:\n\n * \nS: Bust 84 cm (33.1”), Waist 64 cm (25.2”), Shoulder 38 cm (15”), Sleeve 59 cm (23.2”), Hip 88 cm (34.6”), Length 83 cm (32.7”)\n\n * \nM: Bust 88 cm (34.6”), Waist 68 cm (26.8”), Shoulder 39 cm (15.4”), Sleeve 60 cm (23.6”), Hip 92 cm (36.2”), Length 84 cm (33.1”)\n\n * \nL: Bust 92 cm (36.2”), Waist 72 cm (28.3”), Shoulder 40 cm (15.7”), Sleeve 61 cm (24”), Hip 96 cm (37.8”), Length 85 cm (33.5”)\n\nNote: Manual measurements may vary by 1–3 cm (0.4–1.2”).\n",
  tags: [],
  msrpDollars: 117.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:04.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
